import React, { useState } from 'react';
import { useStore } from '../hooks/useStore';
import { LockIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
import { DoorStrip, DOOR_PALETTE } from '../components/DoorStrip';
export function LoginPage({
  onNavigate
}: {
  onNavigate: (page: string) => void;
}) {
  const {
    adminLogin
  } = useStore();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (adminLogin(username, password)) {
      onNavigate('dashboard');
    } else {
      setError(true);
      setPassword('');
    }
  };
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-339">
      <div className="relative bg-black overflow-hidden pt-24 pb-12 px-6 text-center" data-id="element-340">
        <div className="relative z-10" data-id="element-341">
          <img src="https://cdn.magicpatterns.com/uploads/ewfDCj5QKNDNeQRsTcwjBG/logo_de_Junquito_Gas_(4).ai_(4).png" alt="La Cochera" className="h-12 mx-auto mb-6" data-id="element-342" />
          <h1 className="font-display text-4xl font-extrabold text-white tracking-tight mb-6" data-id="element-343">
            Panel Admin
          </h1>
          <div className="flex justify-center gap-1" data-id="element-344">
            {DOOR_PALETTE.map((c, i) => <div key={i} className="w-8 h-1 rounded-full" style={{
            backgroundColor: c
          }} data-id="element-345" />)}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0" data-id="element-346">
          <DoorStrip height="h-2" data-id="element-347" />
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 py-12" data-id="element-348">
        <div className="w-full max-w-sm" data-id="element-349">
          <div className="bg-white rounded-2xl border border-stone-200 p-10 shadow-xl relative overflow-hidden" data-id="element-350">
            <div className="absolute top-0 left-0 right-0 h-1.5" style={{
            backgroundColor: DOOR_PALETTE[0]
          }} data-id="element-351" />

            <div className="text-center mb-8" data-id="element-352">
              <div className="w-16 h-16 bg-stone-50 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-stone-100" data-id="element-353">
                <LockIcon className="w-8 h-8 text-stone-900" data-id="element-354" />
              </div>
              <p className="text-stone-500 text-sm font-medium" data-id="element-355">
                Acceso exclusivo para administradores
              </p>
            </div>

            {error && <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded-xl text-center" data-id="element-356">
                <p className="text-red-600 text-xs font-bold uppercase tracking-wide" data-id="element-357">
                  Usuario o contraseña incorrectos
                </p>
              </div>}

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-358">
              <div data-id="element-359">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-360">
                  Usuario
                </label>
                <div className="relative" data-id="element-361">
                  <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" data-id="element-362" />
                  <input type="text" value={username} onChange={e => {
                  setUsername(e.target.value);
                  setError(false);
                }} className={`w-full pl-10 pr-4 py-3.5 bg-stone-50 border rounded-xl outline-none transition-all text-sm font-medium ${error ? 'border-red-300 bg-red-50' : 'border-stone-200 focus:ring-2 focus:ring-black/5 focus:border-black'}`} placeholder="admin" autoFocus autoComplete="username" data-id="element-363" />
                </div>
              </div>
              <div data-id="element-364">
                <label className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-2 block" data-id="element-365">
                  Contraseña
                </label>
                <div className="relative" data-id="element-366">
                  <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" data-id="element-367" />
                  <input type="password" value={password} onChange={e => {
                  setPassword(e.target.value);
                  setError(false);
                }} className={`w-full pl-10 pr-4 py-3.5 bg-stone-50 border rounded-xl outline-none transition-all text-sm font-medium tracking-widest ${error ? 'border-red-300 bg-red-50' : 'border-stone-200 focus:ring-2 focus:ring-black/5 focus:border-black'}`} placeholder="••••••••" autoComplete="current-password" data-id="element-368" />
                </div>
              </div>
              <button type="submit" className="w-full py-4 bg-black text-white font-bold rounded-xl hover:bg-stone-800 transition-colors flex items-center justify-center gap-2 text-sm uppercase tracking-widest mt-2" data-id="element-369">
                Ingresar <ArrowRightIcon className="w-4 h-4" data-id="element-370" />
              </button>
            </form>

            <button onClick={() => onNavigate('home')} className="w-full mt-6 text-xs font-bold text-stone-400 hover:text-black transition-colors text-center uppercase tracking-widest" data-id="element-371">
              ← Volver al sitio
            </button>
          </div>
        </div>
      </div>
    </div>;
}